import React, { useEffect } from 'react';

import "./core-pop-up.css"
import { TextHtmlTagType } from '../../../../misc/tools';

const CorePopUp = (props: CorePopUpConfig) => {

	return (
		<div className="modal-disable-select center-element main-content core-pop-up-container opaque" style={{
			...props.style
		}}>
			<div className='core-pop-up-row'>
				<h1 tabIndex={0} id={props.topId} className=' core-pop-up-title white-text text-manual-edit-h1'>{props.title}</h1>
				{props.subtitle ? <h1 tabIndex={0} className='core-pop-up-title white-text text-manual-edit-h1'>{props.subtitle}</h1>: (null)}
			</div>

			<div className='core-pop-up-description core-pop-up-row'>
				{props.onRenderContent()}
			</div>
		</div>
	);

};

export interface CorePopUpConfig {
	title: string;
	topId?: string;
	subtitle?: string;
	style?: any;
	onRenderContent: () => any;
}

export default CorePopUp;